import { render, staticRenderFns } from "./Environments.vue?vue&type=template&id=509617c6&"
import script from "./Environments.vue?vue&type=script&lang=ts&"
export * from "./Environments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports